"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormReact = exports.Form = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _store = require("../store");
var _propTypes = _interopRequireDefault(require("prop-types"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var FormReact = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(FormReact, _React$Component);
  var _super = _createSuper(FormReact);
  function FormReact() {
    var _this;
    (0, _classCallCheck2.default)(this, FormReact);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderHelperAndError", function (name) {
      var form = _this.props.form;
      var currentFocus = form.currentFocus,
        formFields = form.formFields;
      var currField = formFields[name];
      var value = currField.value,
        key = currField.key,
        errors = currField.errors,
        helperText = currField.helperText;
      var content = errors.length > 0 && currentFocus !== key ? /*#__PURE__*/_react.default.createElement("span", {
        id: "".concat(name, "-error-txt"),
        "data-error-id": "".concat(name, "-error"),
        className: "error-txt"
      }, helperText) : errors.length > 0 ? /*#__PURE__*/_react.default.createElement("span", {
        id: "".concat(name, "-helper-txt"),
        className: "helper-txt"
      }, helperText) : value !== '' ? /*#__PURE__*/_react.default.createElement("span", {
        id: "".concat(name, "-helper-txt"),
        className: "helper-txt"
      }, "Format looks good!") : /*#__PURE__*/_react.default.createElement("span", {
        id: "".concat(name, "-helper-txt"),
        className: "helper-txt"
      }, helperText);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-6"
      }, content);
    });
    return _this;
  }
  (0, _createClass2.default)(FormReact, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        siteInfo = _this$props.siteInfo,
        form = _this$props.form,
        validateAndSubmit = _this$props.validateAndSubmit,
        updateFormField = _this$props.updateFormField;
      var genericError = form.genericError,
        formFields = form.formFields;
      var email = formFields.email,
        password = formFields.password,
        confirmPassword = formFields.confirmPassword;
      var containerClass = siteInfo && (siteInfo.realm === 'LCYTS' || siteInfo.realm === 'LCK12') ? 'account-create-login-container yts-parent' : siteInfo && siteInfo.realm === 'LCPS' ? 'account-create-login-container lcps-parent' : 'account-create-login-container';
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "account-create-login-body",
        className: containerClass
      }, /*#__PURE__*/_react.default.createElement("h1", null, "Please create a password"), /*#__PURE__*/_react.default.createElement("form", {
        className: "form",
        id: "account-create-login-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "col-sm-2 form-label",
        htmlFor: "email"
      }, "Email"), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-4"
      }, /*#__PURE__*/_react.default.createElement("input", {
        disabled: true,
        type: "text",
        className: "form-control",
        name: "email",
        "data-error-target": "email-error",
        value: email.value
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-6 padding-top-5"
      }, /*#__PURE__*/_react.default.createElement("span", {
        "data-error-id": "email-error"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "col-sm-2 form-label",
        htmlFor: "password"
      }, password.title), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-4"
      }, /*#__PURE__*/_react.default.createElement("input", {
        onFocus: updateFormField,
        onChange: updateFormField,
        placeholder: "Password",
        type: "password",
        className: "form-control",
        name: "password",
        "data-error-target": "password-error",
        "data-help-target": "password-help",
        value: password.value
      })), this.renderHelperAndError('password')), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "col-sm-2 form-label",
        htmlFor: "confirmPassword"
      }, confirmPassword.title), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-4"
      }, /*#__PURE__*/_react.default.createElement("input", {
        onFocus: updateFormField,
        onChange: updateFormField,
        placeholder: "Password",
        type: "password",
        className: "form-control",
        name: "confirmPassword",
        "data-error-target": "confirmPassword-error",
        value: confirmPassword.value
      })), this.renderHelperAndError('confirmPassword')), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-12 padding-top-15 submit-btn"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: validateAndSubmit,
        className: "btn btn-yts-blue"
      }, "Submit"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "error-txt"
      }, genericError)));
    }
  }]);
  return FormReact;
}(_react.default.Component);
exports.FormReact = FormReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    modal: state.modal,
    siteInfo: state.siteInfo,
    form: state.form
  };
};
FormReact.propTypes = {
  form: _propTypes.default.object,
  siteInfo: _propTypes.default.object,
  validateAndSubmit: _propTypes.default.func,
  updateFormField: _propTypes.default.func
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var Form = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FormReact);
exports.Form = Form;
